/**
 * Section-concept mapping for cross-geo section compare. Static reference data
 * (11 concepts × 5 regions) — fetched once and cached for the session.
 */
import { useQuery } from '@tanstack/react-query';
import { authApi } from '../services/authApi';
import type { SectionConcept } from '../types';

export function useSectionConcepts() {
  const { data } = useQuery<SectionConcept[]>({
    queryKey: ['section-concepts'],
    queryFn: async () => (await authApi.listSectionConcepts()).concepts,
    staleTime: 60 * 60 * 1000, // reference data — effectively static
    retry: false,
  });
  return data ?? [];
}
